/**
 * https://imagedelivery.net/<ACCOUNT_HASH>/<IMAGE_ID>/<VARIANT_NAME>
 * variant = "default" image url
 * w1366(max) x h768(max)
 */
export function getPublicCloudflareImageUrl(imageUid: string) {
  const accountId = import.meta.env.VITE_CLOUDFLARE_ACCOUNT_HASH
  return `https://imagedelivery.net/${accountId}/${imageUid}/default`
}

/**
 * https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>
 *
 * - iframe
 *   - https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>/iframe
 * - hls
 *   - https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>/manifest/video.m3u8
 * - thumbnail
 *   - https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>/thumbnails/thumbnail.jpg?time=1s&width=270&height=130
 */
export function getPublicCloudflareVideoHlsUrl(videoUId: string) {
  const customerCode = import.meta.env.VITE_CLOUDFLARE_STREAM_CUSTOMER_CODE
  return `https://customer-${customerCode}.cloudflarestream.com/${videoUId}/manifest/video.m3u8`
}

/**
 * thumbnail
 * - sizeは popup main imageの比率をdefaultにしている
 * - 時間は1秒先から取得 videoは最初真っ黒か真っ白で作られることがしばしばあるので、概ね1秒後のサムネイルを取得する
 */
export function getPublicCloudflareVideoThumbnailUrl(videoUId: string | undefined | null, size?: {
  width: number
  height: number
}) {
  if (!videoUId) {
    return ''
  }

  const customerCode = import.meta.env.VITE_CLOUDFLARE_STREAM_CUSTOMER_CODE
  let thumbnailSize = size
  if (!thumbnailSize) {
    thumbnailSize = { width: 270, height: 130 }
  }
  return `https://customer-${customerCode}.cloudflarestream.com/${videoUId}/thumbnails/thumbnail.jpg?time=1s&width=${thumbnailSize.width}&height=${thumbnailSize.height}`
}
